module.exports = __webpack_public_path__ + "img/dr02.97379705.png";